import getColor from "@insite/mobius/utilities/getColor";
import { cookiePrivacyPolicyPopupStyles as styles } from "@solveindustrial/Overrides/Components/CookiePrivacyPolicyPopup";
import { colorStrings, mediaQueriesBP } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

styles.drawer = {
    ...styles.drawer,
    cssOverrides: {
        ...styles.drawer?.cssOverrides,

        drawerBody: css`
            ${styles.drawer?.cssOverrides?.drawerContainer}
            background: ${getColor(colorStrings.commonGlobalBlack)};
            height: auto;

            ${mediaQueriesBP.minMD} {
                border-radius: 4px;
            }
        `,

        drawerContent: css`
            ${styles.drawer?.cssOverrides?.drawerContent}
            background: ${getColor(colorStrings.commonGlobalBlack)};
            color: ${getColor(colorStrings.commonGlobalWhite)};
            display: flex;
            align-items: center;
            height: 100%;
            padding: 24px;

            font-size: 14px;
            font-weight: 400;
            line-height: 25px;
            letter-spacing: 0;
            text-align: left;

            ${mediaQueriesBP.minMD} {
                min-height: auto;
                border-radius: 4px;
                font-size: 16px;
                line-height: 29px;
                padding: 40px;
            }
        `,
    },
};

styles.ctaGridItem = {
    ...styles.ctaGridItem,
    width: [12, 12, 4, 2, 2],
    css: css`
        ${styles.ctaGridItem?.css}
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    `,
};

styles.container = {
    ...styles.container,
    offsetCss: css`
        ${styles.container?.offsetCss}
        justify-content: space-between;
        align-items: center;
    `,
};

styles.ctaGridItemContainer = {
    ...styles.ctaGridItemContainer,
    gap: 0,
    css: css`
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    `,
    offsetCss: css`
        row-gap: 10px;

        ${mediaQueriesBP.minMD} {
            row-gap: 20px;
        }
    `,
};

styles.acceptGridItem = {
    ...styles.acceptGridItem,
    width: 12,
};

styles.closeGridItem = {
    ...styles.closeGridItem,
    width: 12,
    css: css`
        display: flex;
        ${mediaQueriesBP.minMD} {
            justify-content: center;
        }
    `,
};

styles.closeButtonLink = {
    ...styles.closeButtonLink,
    color: colorStrings.commonGlobalWhite,
    typographyProps: {
        ...styles.closeButtonLink?.typographyProps,
        size: 18,
        lineHeight: "25px",
    },
    hoverStyle: {
        ...styles.closeButtonLink?.hoverStyle,
        color: colorStrings.commonGlobalWhite,
    },
    hoverMode: "lighten",
    css: css`
        ${styles.closeButtonLink?.css}
        color: ${getColor(colorStrings.commonGlobalWhite)};
        display: flex;
        position: relative;

        &::after {
            content: "";
            position: absolute;
            width: 100%;
            transform: scaleX(0);
            height: 2px;
            bottom: 0;
            left: 0;
            background-color: ${getColor(colorStrings.commonGlobalWhite)};
            transform-origin: bottom right;
            transition: transform 0.25s ease-out;
        }

        &:hover,
        &:hover span {
            color: ${getColor(colorStrings.commonGlobalWhite)};

            &::after {
                transform: scaleX(1);
                transform-origin: bottom left;
            }
        }

        ${mediaQueriesBP.minMD} {
            justify-content: center;
        }
    `,
};

styles.messageText = {
    ...styles.messageText,
    css: css`
        ${styles.messageText?.css}
        padding-inline-end: 15px;
    `,
};
